import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function TransferDiscount() {
  const { t } = useTranslation();
  return (
    <section className="relative py-16 md:py-20 bg-background-100/50">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="border border-accent-500/20 bg-background-50 p-8 text-center">
          <div className="w-10 h-10 flex items-center justify-center bg-accent-500/10 rounded-full mx-auto mb-4">
            <i className="ri-arrow-up-double-line text-accent-600 text-base"></i>
          </div>
          <h3 className="font-heading text-[17px] md:text-[16px] text-foreground-900 tracking-[0.06em] mb-3">
            {t('courses.transfer.title')}
          </h3>
          {String(t('courses.transfer.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[14px] text-foreground-500 tracking-[0.04em] leading-relaxed mb-6 max-w-[550px] mx-auto">{__s}</p>))}

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8">
            <div className="bg-background-100/60 border border-background-200/60 px-6 py-4 text-center">
              {String(t('courses.transfer.essentialLabel')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[12px] text-foreground-400 tracking-[0.06em] mb-2">{__s}</p>))}
              <p className="text-[17px] text-accent-600 tracking-[0.06em] font-medium">
                {t('courses.transfer.essentialAmount')}<span className="text-[12px] text-foreground-400">{t('courses.transfer.essentialSuffix')}</span>
              </p>
            </div>

            <div className="hidden sm:flex items-center text-foreground-300">
              <i className="ri-arrow-right-line"></i>
            </div>

            <div className="bg-background-100/60 border border-background-200/60 px-6 py-4 text-center">
              {String(t('courses.transfer.advancedLabel')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[12px] text-foreground-400 tracking-[0.06em] mb-2">{__s}</p>))}
              <p className="text-[17px] text-accent-600 tracking-[0.06em] font-medium">
                {t('courses.transfer.advancedAmount')}<span className="text-[12px] text-foreground-400">{t('courses.transfer.advancedSuffix')}</span>
              </p>
            </div>
          </div>

          <div className="mt-6 pt-5 border-t border-background-200/60">
            <Link
              to="/pricing/details"
              className="text-[14px] text-accent-600 hover:text-accent-500 tracking-[0.05em] transition-colors inline-flex items-center gap-1.5"
            >
              <div className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-information-line text-xs"></i>
              </div>
              {t('courses.transfer.detailLink')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}